import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  Tooltip,
  Typography,
  Grid,
  TablePagination,
} from "@mui/material";
import styles from "../../../styles.module.css";
import {
  Breadcrumb,
  CustomePopover,
  dateConversion,
  DeleteDialog,
  StyledTableCell,
  StyledTableRow,
} from "../../reusableComponent/Reusables";
import HeaderSection from "../../reusableComponent/HeaderSection";
import ReusableSnackbar from "../../reusableComponent/ReusableSnackbar";
import transferToPlantService from "../../../services/transferToPlant.Service";
import CloseIcon from "@mui/icons-material/Close";
import CustomPagination from "../../reusableComponent/CustomPagination";

const Listtrancefaerplant = () => {
  const defaultRowsPerPage = useSelector(
    (state) => state.inward?.rows_per_page || 15
  );
  const totalCount = useSelector((state) => state.inward?.total_count || 0);

  const [rows, setRows] = useState([]);
  const [searchKey, setSearchKey] = useState("");
  const [isDelete, setIsDelete] = useState(false);
  const [deleteInfo, setDeleteInfo] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedCylinderDetails, setSelectedCylinderDetails] = useState([]);
  const [customermap, setCustomer] = useState({}); // Should be populated with customer data
  const [total_count,setTotalCount]=useState(null)
 useEffect(() => {
  if (rows && rows.length > 0) {
    setTotalCount(rows[0]?.totalCount || rows[0]?.total_count || rows.length);
  }
}, [rows]);
  const [controller, setController] = useState({
    page: 0,
    rowsPerPage: defaultRowsPerPage,
  });
  // Safe JSON parsing function
  const safeParse = (jsonString) => {
    if (jsonString && typeof jsonString === "string") {
      try {
        return JSON.parse(jsonString) || [];
      } catch (e) {
        console.error("Error parsing JSON:", e);
        return [];
      }
    }
    return [];
  };

  // Fetch data function
  const fetchData = async () => {
  try {
    const params = {
      page: controller.page,
      size: controller.rowsPerPage,
      searchKey,
    };
    const response = await transferToPlantService.gettransfartoplant(params);
    console.log("API response:", response);
    console.log("First row:", response?.[0]);
    console.log("totalCount field:", response?.[0]?.totalCount, response?.[0]?.total_count);
    setRows(Array.isArray(response) ? response : []);
  } catch (error) {
    console.error("Error fetching data:", error);
    setSuccessMessage("Error fetching data");
  }
};

  useEffect(() => {
    fetchData();
  }, [controller, searchKey]);

  useEffect(() => {
    setController((prev) => ({
      ...prev,
      rowsPerPage: defaultRowsPerPage,
      page: 0,
    }));
  }, [defaultRowsPerPage]);

  
  useEffect(() => {
  
    setCustomer({ 1: "Customer A", 2: "Customer B" });
  }, []);

  const handleChangePage = (event, newPage) => {
    setController((prev) => ({ ...prev, page: newPage }));
  };

 const handleChangeRowsPerPage = (event) => {
    setController({
      ...controller,
      rowsPerPage: parseInt(event.target.value, 10),
      page: 0,
    });
  };
  const handleSearch = (e) => {
    setSearchKey(e.target.value);
  };

  const handleDelete = (row) => {
    setIsDelete(true);
    setDeleteInfo(row);
  };

  const deleteRecord = async (id) => {
    try {
      await transferToPlantService.editDeletetransfartoplant({
        entry_id: id,
        changedUpdatedValue: "delete",
      });
      setIsDelete(false);
      fetchData();
      setSuccessMessage("Record deleted successfully");
    } catch (error) {
      console.error("Error deleting record:", error);
      setSuccessMessage("Error deleting record");
    }
  };

  const handleClose = () => {
    setIsDelete(false);
    setDeleteInfo(null);
  };

  const handleOpenDialog = (row) => {
    console.log("Opening dialog for row:", row);
    setSelectedRow(row);
    setSelectedCylinderDetails(safeParse(row.table_details));
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedRow(null);
    setSelectedCylinderDetails([]);
  };

  const getCylinderCount = (tableDetails) => {
    try {
      const details = safeParse(tableDetails);
      return details.length || 0;
    } catch (error) {
      console.error("Error parsing table_details:", error);
      return 0;
    }
  };

  const getOwnerDisplay = (cylinder) => {
    if (!cylinder) return "N/A";
    const { owner, customer_id } = cylinder;
    if (owner === "TGPL") return "TGPL";
    if (owner === "customer" && customer_id && customermap[customer_id]) {
      return customermap[customer_id];
    }
    return "N/A";
  };

  // Pagination info
  const effectiveTotalCount = total_count > 0 ? total_count : rows.length > 0 ? rows.length : 0;
  const startRecord = effectiveTotalCount === 0 ? 0 : controller.page * controller.rowsPerPage + 1;
  const endRecord = effectiveTotalCount === 0 ? 0 : Math.min((controller.page + 1) * controller.rowsPerPage, effectiveTotalCount);
  const paginationInfo = `${startRecord}-${endRecord} of ${total_count}`;

  return (
    <Box
      className={`${styles.cts_page}`}
      sx={{ padding: "0px !important", margin: "0px !important" }}
    >
      <Box className={`${styles.body}`}>
        <Breadcrumb routeSegments={[{ name: "Transfer to Plant List" }]} />

        <HeaderSection
          title="TRANSFER TO PLANT LIST"
          addNewPath="/storeEntries/addtransertoplant"
          searchKey={searchKey}
          handleSearch={handleSearch}
          sortedRows={rows}

          filename="Transfer to Plant List"
          paginationInfo={paginationInfo}
          controller={controller}
          handleChangePage={handleChangePage}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
          fields={["entry_no", "entry_date","inward_no", "from_location", "to_location","table_details"]}
          labels={["Entry No ","Entry Date", "Inward Entry No","From Location", "To Location", "No Of Cylinder"]}
        />
          

        <Paper sx={{ width: "100%", overflow: "hidden" }}>
         <TableContainer
  component={Paper}
  className={`${styles.list_tbl_container}`}
  sx={{ 
    maxHeight: "calc(100vh - 250px)", // ✅ screen height se adjust
    overflowY: "auto",
    overflowX: "auto",
  }}
>
            <Table size="small" stickyHeader>
              <TableHead>
                <StyledTableRow>
                  <StyledTableCell align="left" className={styles.table_head}>
                    Entry No
                  </StyledTableCell>
                  <StyledTableCell align="left" className={styles.table_head}>
                    Entry Date
                  </StyledTableCell>
                  <StyledTableCell align="left" className={styles.table_head}>
                    Inward Entry No
                  </StyledTableCell>
                  <StyledTableCell align="left" className={styles.table_head}>
                    From Location
                  </StyledTableCell>
                  <StyledTableCell align="left" className={styles.table_head}>
                    To Location
                  </StyledTableCell>
                  <StyledTableCell align="center" className={styles.table_head}>
                    No of Cylinders
                  </StyledTableCell>
                  {/* <StyledTableCell align="center" className={styles.table_head}>
                    Action
                  </StyledTableCell> */}
                </StyledTableRow>
              </TableHead>

              <TableBody sx={{ backgroundColor: "#fff" }}>
                {Array.isArray(rows) && rows.length > 0 ? (
                  rows.map((row) => (
                    <StyledTableRow key={row.entry_id}>

                      <StyledTableCell
                        align="left"
                        className={`${styles.list_table_body}`}
                      >
                        <Typography
                          sx={{
                            fontSize: "12px",
                            fontWeight: "bold",
                            cursor: "pointer",
                            color: "#1976d2",
                            textDecoration: "underline",
                          }}
                          onClick={() => handleOpenDialog(row)}
                        >
                          {row.entry_no || "N/A"}
                        </Typography>

                        
                      </StyledTableCell>

                      
                      <StyledTableCell
                        align="left"
                        className={`${styles.list_table_body}`}
                      >
                        {row.entry_date
                          ? dateConversion(row.entry_date)
                          : "N/A"}
                      </StyledTableCell>
                      <StyledTableCell
                        align="left"
                        className={`${styles.list_table_body}`}
                      >
                        {row.inward_no || "N/A"}
                      </StyledTableCell>
                      <StyledTableCell
                        align="left"
                        className={`${styles.list_table_body}`}
                      >
                        {row.from_location || "N/A"}
                      </StyledTableCell>
                      <StyledTableCell
                        align="left"
                        className={`${styles.list_table_body}`}
                      >
                        {row.to_location || "N/A"}
                      </StyledTableCell>
                      <StyledTableCell
                        align="center"
                        className={`${styles.list_table_body}`}
                      >
                        <Tooltip
                          title="Click here to view cylinder details"
                          arrow
                        >
                          <span
                            onClick={() => handleOpenDialog(row)}
                            style={{ cursor: "pointer" }}
                          >
                            {getCylinderCount(row.table_details)}
                          </span>
                        </Tooltip>
                      </StyledTableCell>
                      {/* <StyledTableCell
                        align="center"
                        className={`${styles.list_table_body}`}
                      >
                        <CustomePopover
                          row={row}
                          handleDelete={false}
                          linkTo="/storeEntries/addtransertoplant"
                          showEdit={false}
                          handlePrint={false}
                          handleCancel={false}
                        />
                      </StyledTableCell> */}
                    </StyledTableRow>
                  ))
                ) : (
                  <StyledTableRow>
                    <StyledTableCell colSpan={7} align="center">
                      No data available
                    </StyledTableCell>
                  </StyledTableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
           
        </Paper>
  <CustomPagination
  page={controller.page}
  rowsPerPage={controller.rowsPerPage}
  totalCount={total_count || 0}
  onPageChange={(newPage) => handleChangePage(null, newPage)}
/>
        {/* ── TRANSFER TO PLANT DETAILS (Redesigned like Sales Order) ── */}
        <Dialog
          open={openDialog}
          onClose={handleCloseDialog}
          maxWidth={false}
          sx={{
            "& .MuiDialog-paper": {
              margin: "auto",
              width: "92vw",
              maxHeight: "85vh",
              boxShadow: "0 8px 32px rgba(0,0,0,0.18)",
              overflow: "hidden",
              fontFamily: "'Inter', Arial, sans-serif",
            
            },
          }}
        >
          {/* ── Dialog Header (Navy) ── */}
          <Box sx={{ background: "#1C3A5E", padding: "10px 19px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <Typography sx={{ fontSize: "14px", fontWeight: 700, color: "#fff", letterSpacing: "0.5px", fontFamily: "'Inter', Arial, sans-serif" }}>
              TRANSFER TO PLANT DETAILS
            </Typography>
            <IconButton onClick={handleCloseDialog} sx={{ color: "#fff", p: 0.5 }}>
              <CloseIcon fontSize="small" />
            </IconButton>
          </Box>

          <DialogContent sx={{ padding: "20px 24px", background: "#F4F7FB", overflowY: "auto" }}>

            {/* ── Transfer Information Card ── */}
            <Box sx={{ background: "#fff", border: "1px solid #E2E8F0",  overflow: "hidden", mb: 2.5 }}>
              <Box sx={{ background: "#2A4F7A", padding: "9px 18px" }}>
                <Typography sx={{ fontSize: "12px", fontWeight: 700, color: "#fff", fontFamily: "'Inter', Arial, sans-serif", letterSpacing: "0.4px" }}>
                  📋  Transfer Information
                </Typography>
              </Box>

              <Box>
                <Grid container>
                  <Grid item xs={12} sm={6} md={2.4} sx={{ borderRight: "1px solid #EDF2F7", borderBottom: "1px solid #EDF2F7", padding: "12px 16px" }}>
                    <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "#718096", textTransform: "uppercase", letterSpacing: "0.6px", mb: 0.5, fontFamily: "'Inter', Arial, sans-serif" }}>Entry No</Typography>
                    <Typography sx={{ fontSize: "14px", fontWeight: 700, color: "#1C3A5E", fontFamily: "'Inter', Arial, sans-serif" }}>{selectedRow?.entry_no || "N/A"}</Typography>
                  </Grid>
                  <Grid item xs={12} sm={6} md={2.4} sx={{ borderRight: "1px solid #EDF2F7", borderBottom: "1px solid #EDF2F7", padding: "12px 16px" }}>
                    <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "#718096", textTransform: "uppercase", letterSpacing: "0.6px", mb: 0.5, fontFamily: "'Inter', Arial, sans-serif" }}>Entry Date</Typography>
                    <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#2D3748", fontFamily: "'Inter', Arial, sans-serif" }}>{selectedRow?.entry_date ? dateConversion(selectedRow.entry_date) : "N/A"}</Typography>
                  </Grid>
                  <Grid item xs={12} sm={6} md={2.4} sx={{ borderRight: "1px solid #EDF2F7", borderBottom: "1px solid #EDF2F7", padding: "12px 16px" }}>
                    <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "#718096", textTransform: "uppercase", letterSpacing: "0.6px", mb: 0.5, fontFamily: "'Inter', Arial, sans-serif" }}>Inward No</Typography>
                    <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#2D3748", fontFamily: "'Inter', Arial, sans-serif" }}>{selectedRow?.inward_no || "N/A"}</Typography>
                  </Grid>
                  <Grid item xs={12} sm={6} md={2.4} sx={{ borderRight: "1px solid #EDF2F7", borderBottom: "1px solid #EDF2F7", padding: "12px 16px" }}>
                    <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "#718096", textTransform: "uppercase", letterSpacing: "0.6px", mb: 0.5, fontFamily: "'Inter', Arial, sans-serif" }}>Plant</Typography>
                    <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#2D3748", fontFamily: "'Inter', Arial, sans-serif" }}>{selectedRow?.from_location || "N/A"}</Typography>
                  </Grid>
                  <Grid item xs={12} sm={6} md={2.4} sx={{ borderBottom: "1px solid #EDF2F7", padding: "12px 16px" }}>
                    <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "#718096", textTransform: "uppercase", letterSpacing: "0.6px", mb: 0.5, fontFamily: "'Inter', Arial, sans-serif" }}>From Location</Typography>
                    <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#2D3748", fontFamily: "'Inter', Arial, sans-serif" }}>{selectedRow?.to_location || "N/A"}</Typography>
                  </Grid>
                </Grid>
              </Box>
            </Box>

            {/* ── Cylinder Details Table ── */}
            <Box sx={{ background: "#fff", border: "1px solid #E2E8F0",  overflow: "hidden" }}>
             

              <TableContainer sx={{ maxHeight: "320px" }}>
                <Table size="small" stickyHeader>
                  <TableHead>
                    <StyledTableRow>
                      {["Sr No", "Cylinder No", "Owner", "Status", "Note"].map((header) => (
                        <StyledTableCell
                          key={header}
                          align="center"
                          sx={{
                            backgroundColor: "#1C3A5E !important",
                            color: "#fff !important",
                            fontFamily: "'Inter', Arial, sans-serif",
                            fontWeight: 700,
                            fontSize: "12px",
                            padding: "10px 12px",
                            whiteSpace: "nowrap",
                            borderRight: "1px solid rgba(255,255,255,0.1)",
                          }}
                        >
                          {header}
                        </StyledTableCell>
                      ))}
                    </StyledTableRow>
                  </TableHead>
                  <TableBody>
                    {selectedCylinderDetails.length > 0 ? (
                      selectedCylinderDetails.map((row, index) => (
                        <StyledTableRow
                          key={index}
                          sx={{
                            backgroundColor: index % 2 === 0 ? "#fff" : "#F8FAFC",
                            "&:hover": { backgroundColor: "#EBF4FF" },
                          }}
                        >
                          {[
                            index + 1,
                            row.cylinder_no || "N/A",
                            row.owner === "TGPL"
                              ? "TGPL"
                              : row.customer_id
                              ? customermap[row.customer_id] || "Customer"
                              : "N/A",
                            row.status || "N/A",
                            row.note || "N/A"
                          ].map((val, ci) => (
                            <StyledTableCell
                              key={ci}
                              align="center"
                              sx={{
                                fontSize: "12px",
                                fontFamily: "'Inter', Arial, sans-serif",
                                color: "#2D3748",
                                padding: "8px 12px",
                                borderBottom: "1px solid #EDF2F7",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {val}
                            </StyledTableCell>
                          ))}
                        </StyledTableRow>
                      ))
                    ) : (
                      <StyledTableRow>
                        <StyledTableCell
                          colSpan={5}
                          align="center"
                          sx={{ py: 5, fontSize: "13px", color: "#A0AEC0", fontFamily: "'Inter', Arial, sans-serif" }}
                        >
                          No cylinder details available
                        </StyledTableCell>
                      </StyledTableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>

          </DialogContent>

          {/* ── Dialog Footer ── */}
          <Box sx={{ padding: "12px 24px", background: "#F8FAFC", borderTop: "1px solid #E2E8F0", display: "flex", justifyContent: "flex-end" }}>
            <Button
              onClick={handleCloseDialog}
              sx={{
                background: "#E53E3E",
                color: "#fff",
                fontSize: "13px",
                fontWeight: 600,
                textTransform: "none",
                padding: "7px 20px",
                borderRadius: "8px",
                fontFamily: "'Inter', Arial, sans-serif",
                "&:hover": { background: "#971f16" },
              }}
            >
              Close
            </Button>
          </Box>
        </Dialog>

        <DeleteDialog
          open={isDelete}
          handleClose={handleClose}
          deleteInfo={deleteInfo}
          deleteRecord={deleteRecord}
          deleteID={deleteInfo?.entry_id || null}
          displayName={deleteInfo?.entry_id || ""}
        />

        <ReusableSnackbar
          open={!!successMessage}
          onClose={(event, reason) => {
            if (reason !== "clickaway") {
              setSuccessMessage("");
            }
          }}
          message={successMessage}
          autoHideDuration={2000}
          vertical="top"
          horizontal="right"
        />
      </Box>
    </Box>
  );
};

export default Listtrancefaerplant;